<template>
<v-app>
    <Menu />
    <v-content>
        <v-container fluid>
            <router-view></router-view>
        </v-container>
    </v-content>
</v-app>
</template>

<script>
import userprofile from '@/api/userprofile/userprofile.js'
import createfoodbom from '@/api/createfoodbom/createfoodbom.js'
import Menu from '@/components/menuadmin/Menu.vue'
export default {
    name: 'pageAll',
    components: {
        Menu,
    },
    methods: {
        async userProfile() {
            userprofile.userProfile().then((response) => {
                if (response.data.successful === true) {
                    this.$store.commit('userProfileSuccess', response.data.userProfile)

                    //เฉพาะสิทธ์ Admin ที่เข้าได้
                    if (this.$route.path == '/' || this.$route.path == '/dashboard' || this.$route.path == '/lotdetailinedit' || this.$route.path == '/lotdetailoutedit') {
                        if (response.data.userProfile.permission_type == 0) {
                            this.$router.push('/restaurant')
                        }
                    }

                    // Team ทีมงาน
                    if (this.$route.path == '/myteam' || this.$route.path == '/editteam') {
                        if (response.data.userProfile.per_my_team == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/addteam') {
                        if (response.data.userProfile.per_add_team == 0) {
                            this.$router.push('/restaurant')
                        }
                    }

                    // Sales ยอดขาย
                    if (this.$route.path == '/dailycostreport') {
                        if (response.data.userProfile.per_cost_sell == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/salestatistic') {
                        if (response.data.userProfile.per_statistic_food == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/salereport') {
                        if (response.data.userProfile.per_see_all_report == 0) {
                            this.$router.push('/restaurant')
                        }
                    }

                    // Stock คลัง
                    if (this.$route.path == '/stockreport') {
                        if (response.data.userProfile.per_inventory_report == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/materialnow') {
                        if (response.data.userProfile.per_raw_material == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/addlotinpo' || this.$route.path == '/addlotin') {
                        if (response.data.userProfile.per_materials_add_warehouse == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/alllot' || this.$route.path == '/lotdetailin' || this.$route.path == '/lotdetailinedit' || this.$route.path == '/lotdetailout' || this.$route.path == '/lotdetailoutedit') {
                        if (response.data.userProfile.per_warehouse_in_out == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/purchaseorder' || this.$route.path == '/purchaseordernew' || this.$route.path == '/purchaseordernewdetail' || this.$route.name == 'purchaseOrderDetail') {
                        if (response.data.userProfile.per_material_purchase_order == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/stocktype' || this.$route.path == '/stocksource' || this.$route.path == '/stockunit' || this.$route.path == '/stockzone') {
                        if (response.data.userProfile.per_setup_stock == 0) {
                            this.$router.push('/restaurant')
                        }
                    }

                    // Restaurant ร้านอาหาร
                    if (this.$route.path == '/addfood' || this.$route.path == '/addtopping') {
                        if (response.data.userProfile.per_add_food == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/fooddetail' || this.$route.path == '/toppingdetail') {
                        if (response.data.userProfile.per_edit_food == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/buffetmanage') {
                        if (response.data.userProfile.per_setup_buffe == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/advertisebuffet' || this.$route.path == '/advertisesingledishmeal' || this.$route.path == '/advertisetakeout') {
                        if (response.data.userProfile.per_setup_advertise == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/billretrospectall') {
                        if (response.data.userProfile.per_invoice_retrospect == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/salereportday') {
                        if (response.data.userProfile.per_report_retrospect == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/closeretrospectall' || this.$route.path == '/closeretrospectdetail') {
                        if (response.data.userProfile.per_see_close == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/settingrestaurant') {
                        if (response.data.userProfile.per_setting_store == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    createfoodbom.createFoodBom()
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        }
    },
    beforeMount() {
        this.userProfile()
    },
    watch: {
        $route() {
            this.userProfile()
        },
    }
}
</script>
